var map = {
	"./1AGP.png": 61196,
	"./2AGP.png": 92165,
	"./3AGP.png": 12897,
	"components/Catalog/AGP/img/glass/pr/prPlusWhite/1AGP.png": 61196,
	"components/Catalog/AGP/img/glass/pr/prPlusWhite/2AGP.png": 92165,
	"components/Catalog/AGP/img/glass/pr/prPlusWhite/3AGP.png": 12897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11222;